import React from "react";
import SiteAction from "components/site/SiteAction";
import { Col, Container, Row } from "components/site/SitePrimitives";

function renderAction(action) {
  const className = `site-btn ${
    action.variant === "primary" ? "site-btn-primary" : "site-btn-secondary"
  }`;

  if (action.external) {
    return (
      <SiteAction
        className={className}
        external
        key={action.label}
        to={action.to}
      >
        {action.label}
      </SiteAction>
    );
  }

  return (
    <SiteAction
      className={className}
      key={action.label}
      to={action.to}
    >
      {action.label}
    </SiteAction>
  );
}

function PageHero({
  eyebrow,
  title,
  description,
  supportLine,
  actions = [],
  aside,
  compact = false,
  heroClassName = "",
  sectionId,
}) {
  const resolvedHeroClassName = [
    compact ? "site-hero site-hero-compact" : "site-hero site-hero-home",
    heroClassName,
  ]
    .filter(Boolean)
    .join(" ");

  const rowClassName = compact
    ? "align-items-end site-grid-gap"
    : "align-items-center site-grid-gap";

  return (
    <section className={resolvedHeroClassName} id={sectionId}>
      <Container>
        <Row className={rowClassName}>
          <Col lg={aside ? "7" : "10"}>
            <p className="site-eyebrow">{eyebrow}</p>
            <h1>{title}</h1>
            <p className="site-hero-description">{description}</p>
            {supportLine ? (
              <p className="site-hero-support">{supportLine}</p>
            ) : null}
            {actions.length ? (
              <div className="site-page-actions">
                {actions.map((action) => renderAction(action))}
              </div>
            ) : null}
          </Col>
          {aside ? (
            <Col lg="5">
              <div className="site-panel site-hero-panel">{aside}</div>
            </Col>
          ) : null}
        </Row>
      </Container>
    </section>
  );
}

export default PageHero;
